<div class="file-list" [class.hidden]="!visible" [class.full]="mode === 'full'" [class.disabled-element]="deleting">
  <!-- Botón subida de archivos -->
  @if (deleting) {
    <div class="iese-rounded-button secondary">
      <i class="pi pi-spin pi-spinner"></i>
    </div>
  } @else {
    <icbc-upload-files-button />
  }

  <!-- Lista de archivos existentes (anteriores interacciones con el chat) -->
  @if (chatFiles && chatFiles.length > 0) {
    @for (file of chatFiles; track $index) {
      <p-chip styleClass="chat-file-chip"
              (mouseenter)="showFileInfo(file, fileInfoOverlay, $event)"
              (mousemove)="refreshOverlay(file, fileInfoOverlay, $event)"
              (mouseleave)="hideFileInfo(fileInfoOverlay)">
        <div [uidsFileTypeIcon]="file.type" styleClass="file-icon-small"></div>
        <span class="file-chip-filename">{{ file.name }}</span>
        <div class="iese-rounded-button primary small" (click)="deleteHistoryFile(file)">
          <i class="pi pi-times"></i>
        </div>
        <p-overlayPanel styleClass="iese-overlay-panel" #fileInfoOverlay>
          @if (selectedFile === file) {
            <div class="flex align-items-center gap-3">
              <div [uidsFileTypeIcon]="file.type" styleClass="file-icon-medium"></div>
              <div>
                <div class="font-bold">{{ file.name }}</div>
                <div class="text-sm">
                  Type: {{ file.type | fileMimetype }}
                </div>
                <div class="text-sm">
                  Size: {{ file.size | fileSize }}
                </div>
                <div class="text-sm">
                  Last modified: {{ file.lastModified | date: 'medium' }}
                </div>
              </div>
            </div>
          }
        </p-overlayPanel>
      </p-chip>
    }
  }

  <!-- Lista de archivos temporales (las que se quieren subir en la sesión actual) -->
  @if (tempFiles && tempFiles.length > 0) {
    @for (file of tempFiles; track $index) {
      <p-chip styleClass="file-chip"
              (mouseenter)="showFileInfo(file, fileInfoOverlay, $event)"
              (mousemove)="refreshOverlay(file, fileInfoOverlay, $event)"
              (mouseleave)="hideFileInfo(fileInfoOverlay)">
        <div [uidsFileTypeIcon]="file.type" styleClass="file-icon-small"></div>
        <span class="file-chip-filename">{{ file.name }}</span>
        <div class="iese-rounded-button primary small" (click)="removeTempFile(file, fileInfoOverlay)">
          <i class="pi pi-times"></i>
        </div>
        <p-overlayPanel styleClass="iese-overlay-panel" #fileInfoOverlay>
          @if (selectedFile === file) {
            <div class="flex align-items-center gap-3">
              <div [uidsFileTypeIcon]="file.type" styleClass="file-icon-medium"></div>
              <div>
                <div class="font-bold">{{ file.name }}</div>
                <div class="text-sm">
                  Type: {{ file.type | fileMimetype }}
                </div>
                <div class="text-sm">
                  Size: {{ file.size | fileSize }}
                </div>
                <div class="text-sm">
                  Last modified: {{ file.lastModified | date: 'medium' }}
                </div>
              </div>
            </div>
          }
        </p-overlayPanel>
      </p-chip>
    }
  }
</div>
